<template>
  <div id="home-right" ref="appRef">
    <div class="d-flex">
      <div class="top-left">
        <dv-border-box-13 :color="['#1b60cc', '#17caf0']">
          <TopLeftChart :cdata="guideData" v-if="guideData.xAxisData" />
        </dv-border-box-13>
      </div>
      <div class="top-right">
        <dv-border-box-10 :color="['#1b60cc', '#17caf0']">
          <TopRightChart :cdata="resourceData" v-if="resourceData.data" />
        </dv-border-box-10>
      </div>
    </div>
    <div class="d-flex bottom">
      <div class="bottom-left">
        <h3>课程类型占比</h3>
        <BottomLeftChart :cdata="typeData" v-if="typeData.data" />
      </div>
      <div class="bottom-right">
        <h3>各校课程开展情况</h3>
        <div class="top5box">
          <div class="box" v-for="(item, idx) in courseData" :key="idx">
            <BottomRightChart :cdata="item" />
          </div>
        </div>
      </div>
    </div>
    <div class="backBtn">
      <el-button type="primary" @click="btnBack">返回指导中心</el-button>
    </div>
  </div>
</template>

<script>
// import drawMixin from '@/utils/drawMixin';
import TopLeftChart from '_c/echart/right/topLeft/chart.vue';
import TopRightChart from '_c/echart/right/topRight/chart.vue';
import BottomLeftChart from '_c/echart/right/bottomLeft/chart.vue';
import BottomRightChart from '_c/echart/right/bottomRight/chart.vue';

import { getDataByUrl } from '@/api/index.js';

import {
  // guideTime,
  // schoolFile,
  schoolCourse,
  courseNUm,
  resourcesSupport
} from '@/api/area/right1.js';

export default {
  // mixins: [drawMixin],
  components: {
    TopLeftChart,
    TopRightChart,
    BottomLeftChart,
    BottomRightChart
  },
  data() {
    return {
      guideData: {
        // xAxisData: [月份1, 月份2, 月份3],
        // yAxisData: [
        //   {
        //     seriesName: '紧急事件',
        //     seriesData: [2, 1, 3]
        //   },
        //   {
        //     seriesName: '常规事件',
        //     seriesData: [2, 1, 3]
        //   }
        // ]
      },
      resourceData: {
        // data: [
        //   { value: 10, name: '教案文档' },
        //   { value: 25, name: '表格模板' },
        //   { value: 20, name: '课件PPT' },
        //   { value: 25, name: '教学视频' },
        //   { value: 18, name: '教学资源' }
        // ]
      },
      typeData: {
        data: [
          {
            name: '适应性学科',
            value: 70
          },
          {
            name: '支援教师课程',
            value: 10
          },
          {
            name: '社交游戏课程',
            value: 5
          },
          {
            name: '注意力障碍课程',
            value: 5
          },
          {
            name: '学习障碍课程',
            value: 5
          },
          {
            name: '其他特需课程',
            value: 5
          }
        ]
      },
      courseData: [
        {
          color: '#DADC36',
          max: 60,
          school: '上海市青浦区辅读学校',
          seriesData: [32, 16],
          xData: ['语文学科支持', '数学学科支持']
        },
        {
          color: '#00FE67',
          max: 60,
          school: '上海市青浦阳阳幼儿园',
          seriesData: [18, 12],
          xData: ['注意力训练课程', '社交游戏课程']
        },
        {
          color: '#0166FF',
          max: 60,
          school: '上海市毓华学校',
          seriesData: [16, 14],
          xData: ['社交游戏课程', '其他特需课程']
        }
      ],

      colorList: ['#DADC36', '#00FE67', '#0166FF', '#33FFFE', '#FF335B']
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.guideTime();
      this.schoolFile();
      this.getCourseType();
      this.getSchoolCourseNums();
    },

    // 巡回指导统计
    async guideTime() {
      getDataByUrl('tour/month').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          let legends = [];
          let xAxisData = [];
          let yAxisData = [];
          data.forEach((item) => {
            if (!legends.includes(item.type)) {
              legends.push(item.type);
            }
            if (!xAxisData.includes(item.time)) {
              xAxisData.push(item.time);
            }
          });
          legends.forEach((legend) => {
            let seriesData = [];
            xAxisData.forEach((xAxis) => {
              let count = 0;
              data.forEach((item) => {
                if (item.type === legend && item.time === xAxis) {
                  count = item.count;
                }
              });
              seriesData.push(count);
            });
            yAxisData.push({ seriesName: legend, seriesData: seriesData });
          });
          this.guideData = { legends, xAxisData, yAxisData };
        }
      });
    },

    // 资源支持统计
    async schoolFile() {
      getDataByUrl('resource').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            let dataArr = data.map((item) => {
              return {
                name: item.type,
                value: item.count
              };
            });
            this.resourceData = {
              data: dataArr
            };
          }
        }
      });
    },
    // 课程类型
    async getCourseType() {
      getDataByUrl('courseType').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          if (data) {
            let dataArr = data.map((item) => {
              return {
                name: item.type,
                value: item.count
              };
            });
            this.typeData = {
              data: dataArr
            };
          }
        }
      });
    },
    getSchoolCourseNums() {
      getDataByUrl('course').then((res) => {
        if (res.code === '0') {
          let data = res.data || [];
          if (data) {
            this.courseData = [
              // {
              //   color: '#DADC36',
              //   max: 60,
              //   school: '太仓市特殊教育学校',
              //   seriesData: [60, 33],
              //   xData: ['语文学科支持', '数学学科支持']
              // },
              // {
              //   color: '#00FE67',
              //   max: 60,
              //   school: '沙溪镇实验小学',
              //   seriesData: [60, 33],
              //   xData: ['认知注意力提升课程', '心理']
              // }
            ];
            let schoolNames = [...new Set(data.map((item) => item.schoolName))];
            let maxCount = Math.max(...data.map((item) => item.count));
            schoolNames.forEach((schoolName) => {
              let schoolData = data.filter(
                (item) => item.schoolName === schoolName
              );
              let seriesData = schoolData.map((item) => item.count);
              let xData = schoolData.map((item) => item.courseName);
              this.courseData.push({
                color:
                  this.colorList[
                    this.courseData.length % this.colorList.length
                  ],
                max: parseInt(maxCount * 1.2),
                school: schoolName,
                seriesData: seriesData,
                xData: xData
              });
            });
          }
        }
      });
    },
    // 处理一下课程数据
    formatCourseData() {
      // let tmp = [];
      // this.courseData.map((item) => {
      //   tmp = tmp.concat(item.seriesData);
      // });

      // let max = Math.max(...tmp);
      // this.courseData.map((item, i) => {
      //   item.max = max;
      //   item.color = this.colorList[i];
      // });

      this.courseData = [
        {
          color: '#DADC36',
          max: 60,
          school: '太仓市特殊教育学校',
          seriesData: [60, 33],
          xData: ['语文学科支持', '数学学科支持']
        },
        {
          color: '#00FE67',
          max: 60,
          school: '沙溪镇实验小学',
          seriesData: [60, 33],
          xData: ['认知注意力提升课程', '心理']
        },
        {
          color: '#0166FF',
          max: 60,
          school: '太仓中心小学',
          seriesData: [45, 36],
          xData: ['潜能开发', '社交技能']
        },
        {
          color: '#33FFFE',
          max: 60,
          school: '红旗幼儿园',
          seriesData: [40, 60],
          xData: ['感知觉统合训练', '生活适应']
        }
      ];
    },
    changeKeys(list) {
      list.forEach((elem) => {
        elem.name = elem.type; //
        elem.value = elem.count || 0; //
        delete elem.type;
        delete elem.count;
      });
      return list;
    },
    // 课程类型占比
    async schoolCourse() {
      const { data } = await schoolCourse();
      console.log(data);
      this.typeData.data = [
        {
          name: '唱游与律动',
          value: 2
        },
        {
          name: '情绪行为管理课程',
          value: 1.5
        },
        {
          name: '精细知觉动作发展课程',
          value: 1
        },
        {
          name: '语文学习支持课程',
          value: 1
        },
        {
          name: '认知注意力提升课程',
          value: 1
        }
      ];

      // this.typeData.data = this.changeKeys(data);
    },
    //课程开展次数(按学校)
    async courseNUm() {
      const { data } = await courseNUm();
      this.courseData = data.reduce((acc, cur) => {
        const { schoolName, type, courseRecordCount } = cur;
        const found = acc.find((item) => item.school === schoolName);
        if (found) {
          found.seriesData.push(courseRecordCount);
          found.xData.push(type);
        } else {
          acc.push({
            school: schoolName,
            seriesData: [courseRecordCount],
            xData: [type]
          });
        }
        return acc;
      }, []);
      this.formatCourseData();
      // console.log(result);
    },
    btnBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
#home-right {
  width: 1920px;
  height: 1080px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;
  // background-color: #0a1531;
  overflow: hidden;
  color: #fff;
  padding-left: 24px;
  padding-top: 90px;
  .top-left {
    width: 50%;
    margin-right: 24px;
    // border: 2px solid #1b60cc;
    // border-radius: 20px;
  }
  .top-right {
    width: 878px;
    // border: 2px solid #1b60cc;
    // border-radius: 20px;
  }
  .bottom {
    margin-top: 14px;
    h3 {
      width: 100%;
      margin-top: 40px;
      font-size: 29px;
      line-height: 29px;
      font-weight: 400;
      color: #17caf0;
      text-align: center;
    }
  }
  .bottom-left {
    width: 356px;
    height: 405px;
    margin-right: 28px;
    background-image: url(~@/assets/images/right-bottom-border1.png);
  }
  .bottom-right {
    width: 1466px;
    height: 404px;
    background-image: url(~@/assets/images/right-bottom-border2.png);
  }

  .top5box {
    width: 100%;
    padding: 30px 30px;
    display: flex;
    justify-content: space-between;
    .box {
      position: relative;
      width: 258px;
      height: 276px;
      border: 1px solid #00c6ff;
      &::after {
        content: ' ';
        position: absolute;
        right: 0;
        top: 0;
        background: #ffffff;
        border-top: 16px solid transparent;
        border-left: 16px solid #0a1531;
      }
    }
  }
}
.backBtn {
  position: fixed;
  top: 30px;
  right: 30px;
}
</style>
